module.exports = __webpack_public_path__ + "img/dcmm_10.03bfcbaf.png";